import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import Navigation from "@/components/maison/Navigation";
import Footer from "@/components/maison/Footer";
import { fetchPaymentStatus } from "@/lib/api";

const COPY = {
  checking: ["Confirming your acquisition", "Please remain on this page while we confirm payment with the bank."],
  paid: ["Your acquisition is confirmed", "A PiérrecDavís concierge will contact you personally to arrange insured private delivery and certification."],
  expired: ["The checkout session expired", "No payment was taken. You may return to the piece and begin again."],
  timeout: ["Payment is still processing", "We will confirm by email once the bank completes the transaction."],
  error: ["We could not confirm this payment", "Please contact the concierge and quote your session reference."],
  cancel: ["Checkout cancelled", "No payment was taken. The piece remains available for private inquiry."],
};

export default function PaymentResultPage({ cancelled = false }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const pieceSlug = params.get("piece");
  const [state, setState] = useState(cancelled ? "cancel" : "checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (cancelled) return;
    if (!sessionId) return setState("error");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const s = await fetchPaymentStatus(sessionId);
        setInfo(s);
        if (s.payment_status === "paid") return setState("paid");
        if (s.status === "expired") return setState("expired");
        if (++tries >= 10) return setState("timeout");
        timer = setTimeout(poll, 2000);
      } catch {
        setState("error");
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [cancelled, sessionId]);

  const [title, body] = COPY[state];
  return (
    <div className="bg-black text-white min-h-screen flex flex-col" data-testid="payment-result-page">
      <Navigation />
      <main className="flex-1 max-w-3xl mx-auto px-6 pt-44 pb-32 text-center">
        <p className="eyebrow">PiérrecDavís · Private Acquisition</p>
        <h1 className="mt-6 font-serif-display text-4xl sm:text-5xl text-white tracking-[0.05em]" data-testid="payment-result-title">
          {title}
        </h1>
        {info?.piece_name && (
          <p className="mt-4 font-serif-body italic text-[var(--pd-gold)] text-lg" data-testid="payment-result-piece">
            {info.piece_name} · {info.reference}
          </p>
        )}
        <p className="mt-6 text-white/60 leading-relaxed" data-testid="payment-result-body">{body}</p>
        <Link
          to={pieceSlug ? `/ultra-fine-jewelry/${pieceSlug}` : "/ultra-fine-jewelry"}
          className="btn-gold mt-12 inline-flex"
          data-testid="payment-result-return"
        >
          <span>{pieceSlug ? "Return to the Piece" : "Return to the Collection"}</span>
        </Link>
      </main>
      <Footer />
    </div>
  );
}
